/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../../../dist';

export const EfficiencyMenuMobileApp = (props: AllieIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path
        d="M16.3333 5.33337L16.3333 10.6667"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66663 10.6666L8.99996 14"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6666 14L27 10.6666"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33331 22.6666L8.33331 22.6666"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3333 22.6666L17.6666 14.6666"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3333 22.6666L28.3333 22.6666"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 26.668H5.66667C3.99224 24.4394 3 21.6689 3 18.6667C3 11.3029 8.96954 5.33337 16.3333 5.33337C23.6971 5.33337 29.6667 11.3029 29.6667 18.6667C29.6667 21.6689 28.6744 24.4394 27 26.668L21 26.6667"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3333 30.6666C18.5425 30.6666 20.3333 28.8758 20.3333 26.6666C20.3333 24.4575 18.5425 22.6666 16.3333 22.6666C14.1242 22.6666 12.3333 24.4575 12.3333 26.6666C12.3333 28.8758 14.1242 30.6666 16.3333 30.6666Z"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
